import React from 'react';
import { ProductListing } from '../../components/ProductListing';
import { InitialProps } from '../../../type';
import { ResellingProgramsContextProvider } from '../../context';

const ProductListingEntry = ({ sellerName, resellingPrograms, isOpenSubscriptionDrawer }: InitialProps) => (
    <ResellingProgramsContextProvider
        sellerName={sellerName}
        resellingPrograms={resellingPrograms}
        isOpenSubscriptionDrawer={isOpenSubscriptionDrawer}
    >
        <ProductListing />
    </ResellingProgramsContextProvider>
);

export default ProductListingEntry;
